<div>
  <mat-progress-bar [color]="passwordStrength.color" class="strength-bar" mode="determinate"
    [value]="passwordStrength.percent"></mat-progress-bar>
  <div *ngIf="hiddenRules">{{ passwordStrength.text }}</div>
  <div *ngIf="hiddenRules">
    <hr />
    <ul>
      <li class="item-list" *ngFor="let rule of missingPasswordRule">
        <div>
          <mat-icon color="warn">{{ "highlight_off" }}</mat-icon>
        </div>
        <div>{{ rule }}</div>
      </li>
    </ul>
  </div>
</div>